import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../../redux/actions/authActions";
import IconButton from "../../common/Button";
import TextField from "../../common/TextField";
import ChipStatus from "../../common/ChipStatus";
import Spacer from "../../common/Spacer";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(login(username, password, false)); // Dispatch the login action

      if (response && response.success) {
        // if the role is admin then redirect to /admin_dashboard otherwise /user_dashboard
        const targetUrl = response.is_admin
          ? "/admin_dashboard/overview"
          : "/mdt_dashboard/overview";

        navigate(targetUrl);
      } else {
        // Handle login failure (e.g., show an error message)
        setError("Login failed. Verify credentials and retry.");
      }
    } catch (err) {
      // Handle any errors that occur during login
      setError(
        err.message || "An unexpected error occurred. Please try again."
      );
    }
  };

  return (
    <form className="login-form" onSubmit={onSubmit}>
      <div className="login-title h4-bold">Log into your account</div>
      <div className="login-form-fields">
        <div className="form-group">
          <label htmlFor="email" className="field-label">
            Email
          </label>
          <TextField
            type="email"
            id="username"
            name="username"
            placeholder="Enter your email"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              if (error) setError("");
            }}
            required
          />
        </div>
        <Spacer />
        <div className="form-group">
          <label htmlFor="password" className="field-label">
            Password
          </label>
          <TextField
            type="password"
            id="password"
            name="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (error) setError("");
            }}
            required
          />
        </div>
        <Spacer />
        <div className="form-utilities">
          <Link to="/forgot_password" className="forgot-password">
            Forgot password?
          </Link>
        </div>
      </div>

      {/* Use the Button component as the submit button */}
      <IconButton
        variant="primary"
        state="idle"
        icon=""
        type="submit"
        width="376px"
      >
        Login
      </IconButton>
      <Spacer />
      {error && (
        <ChipStatus status="danger" autoDismiss={false}>
          {error}
        </ChipStatus>
      )}
    </form>
  );
};

export default Login;
